import { getenv } from '~/settings'

const APP_REGION_JP = 'jp'
const APP_REGION_US = 'us'

export const region: string = getenv('REGIONAL_CONFIGS')?.region

export const isJapan = () => region === APP_REGION_JP
export const isUs = () => region === APP_REGION_US

export const HELP_EMAIL_JP = 'help@fictiv.co.jp'
export const HELP_EMAIL_US = 'help@fictiv.com'

export const FICTIV_HELP_EMAIL = isUs() ? HELP_EMAIL_US : HELP_EMAIL_JP
